<app-filter-section [all]="airlines()" [filtered]="filteredAirlines()" [formGroup]="filters">
  <form [formGroup]="filters" class="cl-form">
    <input type="text" style="width: 100%" formControlName="t"
      placeholder="Filter by ID and name" autofocus>
    <p class="valid-feedback">Filter terms are case-insensitive.</p>
  </form>
</app-filter-section>
<section class="cl-section cl-section-regular">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <table class="cl-table-data">
          <colgroup>
          <col span="1" style="width: 20%">
          <col span="1" style="width: 80%">
        </colgroup>
        <thead>
          <tr>
            <th class="cl-table-head cl-p-tiny ">
              <div>
                ID
              </div>
            </th>
            <th class="cl-table-head cl-p-tiny ">
              <div>
                Name
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          @if (loading || autoNavigating()) {
            <tr class="cl-tr-no-data">
              <td colspan="100" style="text-align: center">
                <div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i>
              </div>
            </td>
          </tr>
        } @else {
          @for (it of filteredAirlines(); track it) {
            <tr>
              <td>
                <a [routerLink]="[it.iata_code]">{{it.iata_code | orgResolver}}</a>
              </td>
              <td>
                <a  [routerLink]="[it.iata_code]">{{it.airline_name  | orgResolver }}</a>
              </td>
            </tr>
          }
        }

      </tbody>

    </table>
  </div>
</div>
</div>
</section>
